import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationGroupMemberEntity } from './notification-group-member.entity';
import { PhoneTopicEntity } from './phone-topic.entity';

@Index(
	'_fk__notification_group_member__id_from',
	['fkNotificationGroupMemberIdFrom'],
	{},
)
@Index('phoneTopicIdCreatedDate', ['createdDate', 'fkPhoneTopicId'], {
	unique: true,
})
@Entity('_notification_auto_response')
export class NotificationAutoResponseEntity extends BaseEntity {
	@Column('int', { name: '_fk__phone_topic__id', unsigned: true })
	public fkPhoneTopicId!: number;

	@Column('int', {
		name: '_fk__notification_group_member__id_from',
		unsigned: true,
	})
	public fkNotificationGroupMemberIdFrom!: number;

	@Column('longtext', { name: '_message' })
	public message!: string;

	@ManyToOne(
		() => PhoneTopicEntity,
		(phoneTopic) => phoneTopic.notificationAutoResponses,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__phone_topic__id', referencedColumnName: 'id' }])
	public fkPhoneTopic!: PhoneTopicEntity;

	@ManyToOne(
		() => NotificationGroupMemberEntity,
		(notificationGroupMember) =>
			notificationGroupMember.notificationAutoResponses,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{
			name: '_fk__notification_group_member__id_from',
			referencedColumnName: 'id',
		},
	])
	public fkNotificationGroupMemberIdFrom2!: NotificationGroupMemberEntity;
}
